import React from 'react';
import * as Styled from './styles';

export const UpcomingRounds = () => {
    return (
        <Styled.Wrapper>
            <Styled.DescriptionWrapper>
                <Styled.Dates>
                    Grand National Festival 9th&#45;11th April 2026
                </Styled.Dates>
                <Styled.Title>WHAT&apos;S COMING UP?</Styled.Title>
                <Styled.Blurb>
                    <strong>
                        Enter ITV7 for free – get all 7 winners correct and the
                        jackpot could be yours!
                    </strong>
                </Styled.Blurb>
            </Styled.DescriptionWrapper>
            <Styled.ScheduleWrapper>
                <Styled.DayWrapper>
                    <Styled.DateWrapper>
                        <Styled.DayNumber>Day</Styled.DayNumber>
                        <Styled.DayNumber>One</Styled.DayNumber>
                    </Styled.DateWrapper>
                    <Styled.InfoWrapper>
                        <Styled.DayInfo>
                            Our most generous Grand National Festival ever kicks
                            off with a{' '}
                            <Styled.Jackpot>&pound;100,000</Styled.Jackpot>{' '}
                            jackpot.
                        </Styled.DayInfo>
                    </Styled.InfoWrapper>
                </Styled.DayWrapper>
                <Styled.DayWrapper>
                    <Styled.DateWrapper>
                        <Styled.DayNumber>Day</Styled.DayNumber>
                        <Styled.DayNumber>Two</Styled.DayNumber>
                    </Styled.DateWrapper>
                    <Styled.InfoWrapper>
                        <Styled.DayInfo>
                            Another day, another{' '}
                            <Styled.Jackpot>&pound;100,000</Styled.Jackpot>{' '}
                            jackpot as we build towards the big one.
                        </Styled.DayInfo>
                    </Styled.InfoWrapper>
                </Styled.DayWrapper>
                <Styled.DayWrapper>
                    <Styled.DateWrapper>
                        <Styled.DayNumber>Day</Styled.DayNumber>
                        <Styled.DayNumber>Three</Styled.DayNumber>
                    </Styled.DateWrapper>
                    <Styled.InfoWrapper>
                        <Styled.DayInfo>
                            Grand National Saturday: The headline day means our
                            final{' '}
                            <Styled.Jackpot>&pound;100,000</Styled.Jackpot>{' '}
                            jackpot is joined by our{' '}
                            <Styled.Jackpot>&pound;50,000</Styled.Jackpot> cash
                            sweepstake, with one winner guaranteed!
                        </Styled.DayInfo>
                    </Styled.InfoWrapper>
                </Styled.DayWrapper>
                <Styled.DayWrapper>
                    <Styled.DateWrapper>
                        <Styled.DayNumber>Day</Styled.DayNumber>
                        <Styled.DayNumber>Four</Styled.DayNumber>
                    </Styled.DateWrapper>
                    <Styled.InfoWrapper>
                        <Styled.DayInfoWithBottomGutter>
                            Sunday Series: The festival may be over, but the
                            prizes keep coming... We have a{' '}
                            <Styled.Jackpot>&pound;25,000</Styled.Jackpot>{' '}
                            jackpot up for grabs as our Sunday Series rollover
                            begins! If the jackpot isn’t won, the prize jumps to{' '}
                            <Styled.Jackpot>&pound;50,000</Styled.Jackpot> for
                            the next Sunday Series raceday on April 26th.
                        </Styled.DayInfoWithBottomGutter>
                    </Styled.InfoWrapper>
                </Styled.DayWrapper>
            </Styled.ScheduleWrapper>
        </Styled.Wrapper>
    );
};

UpcomingRounds.defaultProps = {};

UpcomingRounds.propTypes = {};

export default UpcomingRounds;
